import clsx from 'clsx';
import { HTMLAttributes, useState } from 'react';
import { useEffectOnce } from 'react-use';
import { useLayoutStore } from '../../stores';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface FloatingButtonProps extends HTMLAttributes<HTMLButtonElement> {}

export function FloatingButton({
  className,
  children,
  ...props
}: FloatingButtonProps) {
  const isPad = useLayoutStore.use.isPad();
  const isDesktop = useLayoutStore.use.isDesktop();
  const overMediumScreen = isPad || isDesktop;
  const [hasOnlyProdDesc, setHasOnlyProdDesc] = useState(false);
  useEffectOnce(() => {
    const params = new URLSearchParams(window.location.search);
    setHasOnlyProdDesc(params.has('onlyproddesc'));
  });

  if (hasOnlyProdDesc) {
    return null;
  }

  return (
    <button
      className={clsx(
        'tlw-cursor-pointer tlw-select-none tlw-transition tlw-duration-100 tlw-flex tlw-items-center tlw-gap-2 lg:hover:tlw-bg-pr lg:hover:tlw-text-txt-white lg:active:tlw-bg-pr lg:active:tlw-text-txt-white disabled:tlw-pointer-events-none disabled:tlw-cursor-not-allowed disabled:tlw-bg-gray-400 disabled:tlw-text-txt-white tlw-justify-center tlw-rounded-full tlw-bg-gray-800 tlw-text-txt-white tlw-shadow-lg',
        'tlw-h-10 tlw-w-10 tlw-p-1 md:tlw-size-[50px] md:tlw-p-3',
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}
